const FORMLOS_STAGING_ORIGIN = 'https://nakos.formlos.dev';
const FORMLOS_PRODUCTION_ORIGIN = 'https://www.nakos.de';

export function formlosOrigin(): string {
  return window.location.hostname === 'adressen.nakos.de'
    ? FORMLOS_PRODUCTION_ORIGIN
    : FORMLOS_STAGING_ORIGIN;
}
